import request from '@/utils/request'

export function pageHomeGiftCard(query) {
  return request({
    url: '/biz/giftcard/home-gift-card/page',
    method: 'get',
    params: query
  })
}

export function saveHomeGiftCard(data) {
  return request({
    url: '/biz/giftcard/home-gift-card/save',
    method: 'post',
    data: data
  })
}

export function deleteHomeGiftCard(id) {
  return request({
    url: '/biz/giftcard/home-gift-card/delete',
    method: 'post',
    params: { id }
  })
}
